import React from "react";
import { useNavigate } from "react-router-dom";

export default function SharedFooter({ className = "" }) {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`py-9 px-4 sm:px-6 lg:px-8 bg-emerald-50 border-t border-emerald-100 ${className}`}>
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-1">
            <div className="flex flex-col items-start">
              <img 
                src="/eduzy-logo-transparent.png" 
                alt="Eduzy" 
                className="w-auto cursor-pointer hover:opacity-80 transition-opacity"
                style={{ height: '6rem' }}
                onClick={() => navigate("/")}
              />
              <span className="text-sm text-emerald-600 font-medium tracking-wide -mt-1 ml-1">
                Learn Smart. Learn Easy.
              </span>
            </div>
            <a 
              href="https://contentiumtech.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:opacity-100 opacity-80 transition-opacity"
            >
              <img 
                src="/contentium-tech-logo.svg" 
                alt="Contentium Tech" 
                className="w-auto"
                style={{ height: '4.5rem' }}
              />
            </a>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-5 text-base text-gray-600">
            <a href="/about" className="hover:text-emerald-600 transition-colors">About</a>
            <a href="/contact" className="hover:text-emerald-600 transition-colors">Contact</a>
            <a href="/why-eduzy" className="hover:text-emerald-600 transition-colors">Learn More</a>
            <a href="/faq" className="hover:text-emerald-600 transition-colors">FAQ</a>
            <a href="/privacy" className="hover:text-emerald-600 transition-colors">Privacy</a>
            <a href="/terms" className="hover:text-emerald-600 transition-colors">Terms</a>
            <a href="/refund" className="hover:text-emerald-600 transition-colors">Refund</a>
          </div>
        </div>
        <div className="mt-6 pt-6 border-t border-emerald-200 text-center text-base text-gray-500">
          © {currentYear} Eduzy by Contentium Tech. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
